import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/leads/proposalsSentReportActions'
import * as api from '../../../api/reports/leads/proposalsSentReport'

function* proposalsSentGetLeadList(action) {
  try {
    const payload = yield call(api.getLeadList, action.filters)
    yield put({ type: constants.PROPOSALS_SENT_REPORT_GET_LEAD_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PROPOSALS_SENT_REPORT_GET_LEAD_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* proposalsSentGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({ type: constants.PROPOSALS_SENT_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PROPOSALS_SENT_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* proposalsSentReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.PROPOSALS_SENT_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PROPOSALS_SENT_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchproposalsSentGetLeadList() {
  yield takeLatest(constants.PROPOSALS_SENT_REPORT_GET_LEAD_LIST.ACTION, proposalsSentGetLeadList)
}

function* watchproposalsSentGetOrganizationList() {
  yield takeLatest(
    constants.PROPOSALS_SENT_REPORT_GET_ORGANIZATION_LIST.ACTION,
    proposalsSentGetOrganizationList
  )
}

function* watchproposalsSentReportGetFullReport() {
  yield takeLatest(
    constants.PROPOSALS_SENT_REPORT_GET_FULL_REPORT.ACTION,
    proposalsSentReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchproposalsSentGetOrganizationList),
    fork(watchproposalsSentReportGetFullReport),
    fork(watchproposalsSentGetLeadList)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/leads/proposalsSentSaga.js